'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const ViewTimer = require('./timer');
const template = require('../templates/vote-cta.ejs');
const templateCSS = require('../templates/vote-cta.css.ejs');
const CSSView = require('./css');

module.exports = Backbone.View.extend({
    className: 'view-vote-cta',
    /**
     *
     */
    initialize: function (options) {

        _.bindAll(this, 'render');

        options = options || {};

        this.uid = options.uid;
        this.style_id = this.className + "_" + Math.round(Math.random() * 1000000);
        
        this.$el.addClass(this.style_id);

        this.css = _.extend({
            turbo_vote_banner: this.model.get('copy').turbo_vote_banner,
            turbo_vote_banner_mobile: this.model.get('copy').turbo_vote_banner_mobile
        }, this.model.get('copy')['customization']);

        this.window = this.model.get('window');   
        this.turbo = options.turbo;

        this.countdownView = new ViewTimer({
            model: options.modelTimerClosed,
            allowReset: false,
            countdownCopy: this.model.get('countdownCopy')
        });

        this.listenTo(this.window, 'change:appState', this.renderAll.bind( this ));
        this.listenTo(this.model, 'change:copy', this.renderAll.bind( this ));
    },
    /**
     *
     */
    render: function () {

        if(this.CSSView) {
            this.CSSView.remove();
        }

        this.CSSView = new CSSView({
            model: this.css,
            namespace: '#' + this.uid + ' .' + this.style_id + '.' + this.className,
            template: templateCSS
        });

        Backbone.$('head').append(this.CSSView.render().$el);
        
        var windowState = this.window.get('appState');
        var isClosed = windowState === 'closed' || windowState === 'winner';

        var isTurboWindow = _.checkIfTrue( this.turbo.get('value') );
        var isTurbo = isTurboWindow && !isClosed;

        var appState = isTurbo ? 'turbo' : windowState;

        var viewModel = _.extend({}, this.model.get('copy')[appState], {
            sponsor_text: this.model.get('copy').sponsor_text,
            sponsor_img: this.model.get('copy').sponsor_image,
            isTurbo: isTurbo,
            turbo_vote_headline: this.model.get('copy').turbo_vote_headline,
            turbo_vote_paragraph: this.model.get('copy').turbo_vote_paragraph
        });

        this.$el.html(template(viewModel));

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function() {
        var appState = this.window.get('appState');
        var backgroundImage = this.model.get('copy')['customization']['background_image'];
        var displayCountdown = _.checkIfTrue( this.model.get('copy')['closed']['display_countdown'] ) 
                               && new Date(this.countdownView.model.attributes.endTime) > new Date();                    

        if(appState === 'closed' && displayCountdown) {
            this.$el.find('.tswdg-countdown').show();
            this.$el.find('.tswdg-countdown').html(this.countdownView.render().$el);
            this.countdownView.renderedToDom();
        } else {
            this.$el.find('.tswdg-countdown').hide();
        }

        if(backgroundImage.length) {
            this.$el.addClass('extended');
        } else {
            this.$el.removeClass('extended');
        }
    },
    /**
     * 
     */
    renderAll: function() {
        this.render();
        this.renderedToDom();
    },
    /**
     * Remove header view
     */
    remove: function() {
        this.countdownView.remove();
        this.stopListening();
        Backbone.View.prototype.remove.call( this );
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/vote-cta.js